module.exports = __webpack_public_path__ + "media/audio2.2187b112.mp3";